export const messages = {
  de: require('./de.json'),
  en: require('./en.json'),
  fr: require('./fr.json'),
  it: require('./it.json'),
  nl: require('./nl.json'),
}
